import {date} from "quasar";
import {QTableColumn} from "pansx-utils";
export class RealTimeInfo {
    public id?: number    //id
    public infoName = ''   //资讯名称
    public infoAuthor = '' //资讯作者
    public infoSystem = '' //资讯系统
    public infoType = ''  //资讯类型
    public infoImg = ''    //资讯图片
    public infoReadTime?: number //资讯发布时间
    public infoDetail = '' //咨询详情
    public infoUrl =''     //咨询链接
    public infoStatus=''   //咨询状态
    public createTime?: Date //创建时间
    public updateTime?: Date //更新时间
    public createBy = ''    //创建人
    public updateBy = ''    //修改人
    public static of(o: unknown): RealTimeInfo {
        return Object.assign(new RealTimeInfo(), o);
    }
    public static getColumns(): QTableColumn[] {
        return [];
    }
    public getColumnLabel(field: string) {
        const columns = RealTimeInfo.getColumns();
        const find: QTableColumn | undefined = columns.find(
            (value) => value.field === field,
        );
        if (typeof find !== 'undefined') {
            return find.label;
        }
        return '';
    }
}